import Box from '@mui/material/Box';
import { keyframes, styled } from '@mui/material/styles';

const animate = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(30px);
  }
`;

const jump = keyframes`
  0% {
    transform: translate(0, 0);
  }
  10% {
    transform: translate(10px, -10px);
  }
  20% {
    transform: translate(20px, 10px);
  }
  30% {
    transform: translate(30px, -50px);
  }
  70% {
    transform: translate(-150px, -50px);
  }
  80% {
    transform: translate(-140px, 10px);
  }
  90% {
    transform: translate(-130px, -10px);
  }
  100% {
    transform: translate(-120px, 0);
  }
`;

export const LoaderStyled = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'fixed',
  zIndex: 999999999,
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'rgba(0,0,0,0.1)',
  '& > span': {
    display: 'block',
    width: 20,
    height: 20,
    background: '#eee',
    borderRadius: '50%',
    margin: '0 5px',
    boxShadow: '0 2px 2px rgba(0, 0, 0, 0.2)',
  },
  '& > span:nth-of-type(2)': {
    background: '#f07e6e',
  },
  '& > span:nth-of-type(3)': {
    background: '#84cdfa',
  },
  '& > span:nth-of-type(4)': {
    background: '#5ad1cd',
  },
  '& > span:nth-of-type(5)': {
    background: '#ffffb5',
  },
  '& > span:not(:last-of-type)': {
    animation: `${animate} 1.5s linear infinite`,
  },
  '& > span:last-of-type': {
    animation: `${jump} 1.5s ease-in-out infinite`,
  },
}));
